import { EdgeConfig } from "../typings/Config";

export const defaultEdgeConfig: EdgeConfig = {
  strokeWidth: 1,
  stroke: "#cecece",
  hoveredColor: "#CCCCFF",
  descriptionColor: "#cecece",
  descriptionSize: 10,
  flyLineEffect: "arrow",
};
